<div class="worklist-execute" [ngClass]="{'enabled': enabled}">
  <i [ngClass]="getClass()" (click)="runActions($event)"></i>
</div>
